import Types from "./Types";

// Get last live video
export const getLastLiveVideoRequest = (courseId) => ({
  type: Types.GET_STUDENT_LAST_LIVE_VIDEO_REQUEST,
  payload: courseId,
});

export const getLastLiveVideoSuccess = (data) => ({
  type: Types.GET_STUDENT_LAST_LIVE_VIDEO_SUCCESS,
  payload: data,
});

export const getLastLiveVideoFail = () => ({
  type: Types.GET_STUDENT_LAST_LIVE_VIDEO_FAIL,
});

// Save live video seen
export const saveLiveVideoSeenRequest = (data, action) => ({
  type: Types.SAVE_STUDENT_LIVE_VIDEO_SEEN_REQUEST,
  payload: data,
  action: action,
});

export const saveLiveVideoSeenSuccess = (data) => ({
  type: Types.SAVE_STUDENT_LIVE_VIDEO_SEEN_SUCCESS,
  payload: data,
});

export const saveLiveVideoSeenFail = () => ({
  type: Types.SAVE_STUDENT_LIVE_VIDEO_SEEN_FAIL,
});

// Loading state
export const studentLiveVideosLoading = (isLoading) => ({
  type: Types.STUDENT_LIVE_VIDEOS_LOADING,
  payload: isLoading,
}); 